module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ich02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch02"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Sabrina came downstairs she found the house filled with guests: witches, princesses, a dwarf, and a few knights from King Arthur’s round table. Everyone was munching on snacks and drinking punch while chatting with one another.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("In one corner, Sabrina saw a familiar trio of women. They were known as the Three, a coven of witches who had worked for former Mayor Charming, cleaning up messes the Everafters didn’t want the town’s human population to see. One of the women was Glinda the Good Witch, whose life was chronicled in L. Frank Baum’s "), _c('em', [_vm._v("The Wonderful Wizard of Oz")]), _vm._v(". She wore an emerald-green pantsuit and held a wand with a crystal star on its end. The second woman seemed about a million years old. Her name was Frau Pfefferkuchenhaus, known from the Hansel and Gretel story. Rounding out the group was the beautiful Morgan le Fay, famous for her association with King Arthur. The Three were enjoying ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("some soft cheeses while discussing the latest episode of their favorite televised dancing contest.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In another corner stood a diminutive man in a black suit whom Sabrina had encountered many times before. Mr. Seven, as he was called, was better known as one of the seven dwarfs. Like the Three, he used to work for Mayor Charming, but when the Queen of Hearts won the latest election he was out of a job. He smiled politely when he spotted Sabrina.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sabrina smiled back, then turned to find Daphne sitting on the sofa wearing a shiny sequined tiara. Elvis, the Grimm’s two-hundred-pound Great Dane, lay on the floor, resting his massive head in Daphne’s lap. Snow White sat with them. Looking at the beautiful woman was like staring into the sunrise for too long. Snow was tall and radiant with eyes as blue as the summer sky. Ms. White wasn’t just beautiful; she was also a kind and caring person, as well as an expert in judo, karate, kickboxing, and bow-staff fighting. Granny had hired her to come to the house three times a week to train the girls in self-defense. Ms. White had plenty of free time, since the Queen of Hearts had closed the school where Ms. White taught immediately after taking office. There was no news of when it would reopen, if ever.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("In addition to being out of work, Ms. White was suffering from a broken heart. When she reunited with her former fiancé, William Charming, it seemed as if they were headed down the ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("aisle at last. But the prince had disappeared after losing the election. Snow searched high and low for him, but it was as if he had vanished into thin air.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, Ms. White,” Sabrina said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh? Oh, I’m sorry, Sabrina. Did you say something?” Ms. White asked as she stared blankly across the room. “I think I’m going to get us some wine. Who wants some wine?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um, I’m seven,” Daphne said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course you are,” Snow White said, then rushed toward the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s a little freaked out,” Daphne explained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why? What’s wrong?” Sabrina asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Daphne pointed across the room toward a stunning woman with a dark complexion; eyes like hot chocolate; and a soft, shy smile. Her name was Briar Rose, though most knew her as Sleeping Beauty. Briar had been something of a fixture at the Grimm house lately. Uncle Jake had asked her for help finding a cure for Henry and Veronica, as Briar had plenty of experience with sleeping spells. It was a sincere request at the time, but since then Uncle Jake had developed a crazy crush on her that seemed to grow every day. When she walked into a room, he fumbled his words and tripped over things. Daphne, always the matchmaker, urged him to confess his feelings, but Briar was never without her overprotective fairy godmothers, Buzzflower and Mallobarb. The fairy duo ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("did not like Jake, and they made it clear that they would turn him into a toad if they caught him so much as looking at Briar. Now, it seemed Jake wasn’t the only person who was awkward around the princess.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Briar used to be married to Billy Charming,” Daphne whispered to her sister.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Uncle Jake entered the room, spotted Briar Rose, and nearly fell over the couch in his rush to talk to her. At once Buzzflower and Mallobarb blocked his path, as if they were linebackers protecting a star quarterback.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Poor Uncle Jake,” Sabrina said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s got googly eyes for Briar,” Daphne said as she gave Elvis’s ears a good scratch. The dog’s back leg tapped the floor happily. “You know what? I think we need to find Elvis a girlfriend, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elvis got up with a snort and skulked out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did I say?” Daphne demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He must be a lifetime bachelor,” Sabrina said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Granny rushed to answer a knock at the door. Sabrina and Daphne watched as a young blond woman and an elderly man entered the house. Sabrina didn’t recognize either of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cindy! Tom! What a pleasant surprise. Please come in,” Granny said. “Let me take your jackets.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Cindy was another rare beauty. She had a button nose; high, freckled cheekbones; and a smile so bright it almost blocked out ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("the rest of her face. Tom, on the other hand, must have been nearly eighty years old, with a gaunt face and shaking hands. He wore a tweed jacket and an old-fashioned felt hat. He leaned on a long brown cane and held a leather satchel close to his body.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hope we’re not intruding,” Cindy said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I heard about the get-together and insisted we come right over. I thought we might be able to help,” Tom offered, setting his bag on the floor near the couch. “Even if not, we can at least do the dishes at the end of the night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course! The more the merrier,” Granny said cheerfully. “Cindy, Tom, I think you know everyone here but my granddaughters. Sabrina, Daphne, this is Mr. Baxter and his wife, Dr. Baxter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you Everafters?” Daphne asked hopefully, shaking the old man’s hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom laughed. “Alas, I’m not, but my wife is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daphne raised her eyebrows and gazed at the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m Cinderella,” Cindy admitted with an embarrassed smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daphne let out a squeal so loud that everyone in the house fell silent and stared. Even Elvis bolted back into the room. The little girl bit down hard on the palm of her hand. It was an odd quirk she displayed when she was excited or happy or both.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yobubbaingalllah,” Daphne said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pardon?” Cindy asked.")])]), _c('p', {
    staticClass: "imageap"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0031-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("“She’s a little excited to meet you,” Sabrina said.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Daphne took her hand out of her mouth. “I might barf!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cindy smiled. “It’s very nice to meet you girls. Your father was—I mean, is—one of my favorite people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He has such a kind spirit,” Tom added.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re big fans, too,” Sabrina said, shaking the man’s hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cindy hosts a radio program here in town,” Granny explained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And we’ve got great news. We’re about to go national,” Tom said proudly. “We’ve been picked up by a radio syndication company. Soon "), _c('em', [_vm._v("The Dr. Cindy Show")]), _vm._v(" will be broadcast all over the country.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bravo!” Granny Relda said. “Your advice has helped a lot of people here in town. Now you can help even more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What kind of advice?” Sabrina asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I help people settle family arguments,” Cindy replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She does more than that,” Tom said. “Cindy has a natural ability to weed through disputes to find the root of the problem, and then she gives people tools and tips to help make things better. What she does is truly special.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I had a challenging childhood,” Cindy admitted. “I learned to deal with difficult people.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Sabrina watched the old man grab his wife’s hand. He looked at her the way someone looks at a beautiful waterfall. Sabrina had seen that look on her parents’ faces and in the photographs of ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("her grandmother and grandfather. Cindy looked back at her husband with the same expression. "), _c('em', [_vm._v("They’ve sure got googly eyes")]), _vm._v(", Sabrina thought.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Elvis let out a whine from behind the couch, where he was sniffing at the old man’s satchel. Granny pulled the dog away by the collar. “Elvis, behave,” she said. He snorted but did as he was told.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just then, Puck made his entrance in typical fashion, stepping into the room and letting out a tremendous belch. “I’m here!” he announced, as if the crowd had been waiting for him all along.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I’m not a happy camper,” he said to Sabrina. “I look like a fool.” He was wearing the shirt Granny Relda had given him. It had a happy little alligator on it, but Puck had written "), _c('span', {
    staticClass: "small"
  }, [_vm._v("I EAT PEOPLE")]), _vm._v(" in a word balloon above its head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a nice shirt,” Sabrina said, trying to cheer the boy up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Puck sneered. “‘It’s a nice shirt,’” he mocked. “I am the most diabolical villain in the history of the world. I cause chaos and disaster everywhere I go. I can’t be seen in this silly shirt! For one thing, the alligator is smiling. If you want me to wear a shirt with a man-eating beast on it, the beast should be eating a man, not grinning like an idiot. This alligator looks as if it’s ready for some birthday cake, not some poor man’s leg! If Jonas the Betrayer ever saw me in this shirt, I would never live it down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who is Jonas the Betrayer?” Daphne asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Sabrina shrugged.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I think everyone’s here,” Granny said to the group, stopping Puck before he could continue his tirade. “I know that you are all very busy, and it’s not exactly a good time to be seen talking to a Grimm, so I’m grateful to each of you for taking the time to come and offer your help with our dilemma.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mayor Heart isn’t going to tell us who we can and can’t talk to,” Morgan le Fay said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The crowd murmured in agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you,” Granny said. “As you all know, my family has a reputation as problem solvers, but we’ve run into a problem that has us stumped. Today, I’m asking you to put your heads together and find a way to break the spell keeping my son and his wife asleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure we can wake them up,” Briar said, though the rest of the crowd didn’t seem quite so certain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just then, there was another knock at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, a late arrival. Sabrina, could you answer that for me?” Granny asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sabrina hurried to the door, not wanting to miss a second of the meeting. She nearly fell over when she saw who was waiting on the other side. A decrepit old woman dressed in filthy rags peered at her from under bushy white eyebrows. She smelled of death and decay. Behind her, a run-down shack resting atop two enormous chicken legs paced around the front yard.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“Baba Yaga!” Sabrina gasped.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The old crone eyed Sabrina with an angry stare. “I was invited,” she growled, pushing past her. A fold of Baba Yaga’s black gown brushed against Sabrina’s hand as she entered the house. It made the skin on her fingers feel as if she had just plunged them into a pot of boiling water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sabrina reluctantly followed the witch into the living room. Baba Yaga’s arrival caused a few startled people to cry out, but Granny Relda welcomed her warmly and reminded everyone that Baba Yaga was wise and knew a number of magical secrets. After some grumbling, the guests agreed, and the party continued.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guests went upstairs to peek at Sabrina’s dozing parents. Some suggested this spell and that potion; others recommended a number of spirits or ancient druidic incantations. Granny Relda followed everyone around, jotting down each new idea in her spiral-bound notebook. A few guests even tried out a number of charms they had with them, but nothing worked. As the day turned into night, the suggestions petered out.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Before long, the meeting was over. The cookies were eaten and the punch bowl emptied. Everyone wished the Grimms luck before flying off into the night (some quite literally). Just before he left, Mr. Seven suggested that Charming’s kiss might do the trick. Sabrina was willing to give it a try until Briar mentioned that the touch of Charming’s lips might also make Veronica Grimm fall ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("madly in love with him—as it had done with her. Blushing, Snow White and Cinderella both agreed.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry we couldn’t be of more help,” Tom apologized as he retrieved his bag from the living room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll think about it more,” Cindy promised. “There has to be something that will work, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Granny nodded, then showed the couple out. The Grimms were alone again, with no solution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Discouraged, Sabrina crept up to bed. Uncle Jake followed with Daphne cradled in his arms. The little girl was sound asleep, and her tiara had slipped down around her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re not giving up, ’Brina,” Uncle Jake whispered as Sabrina pulled back the blankets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know,” Sabrina said, trying to fake a positive attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her uncle gave her a hug and left. Sabrina lay in the dark, waiting for her eyes to adjust, waiting for the little model airplanes that her father had built when he was growing up to come into view. She closed her eyes tight and fought back tears. She was so tired of waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later that night, Sabrina was suddenly roused from a deep sleep by loud banging on the door downstairs. She peeked over at her snoring sister and crawled out of bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll get it,” she grumbled.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("With every step down the stairs, the knocking grew louder and ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("more insistent. As Sabrina turned the doorknob, it occurred to her that maybe she shouldn’t be opening the door in the middle of the night without an adult. But it was too late. She was already face-to-face with Baba Yaga.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are a thief!” the witch said, pointing her withered finger at Sabrina. An invisible force snatched the girl around the neck, lifting her off the ground and yanking her out of the house. “Give it back to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sabrina couldn’t breathe, let alone deny the witch’s accusation. Helpless and lightheaded, she dangled above the grass, kicking her legs wildly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you return what you took, I promise to kill you quickly,” Baba Yaga added.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hag, Sabrina Grimm is under the protection of the Trickster King,” a voice announced. Puck flew into the yard with his wooden sword in hand. He circled the witch while keeping an eye on her shack stomping around the front yard. “Leave her be, or you will face the wrath of the Blood King of Faerie; the Prince of the Wrong Side of the Tracks; the beacon of hope for all good-for-nothings, slackers, and delinquents; the spiritual leader of—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Before Puck could finish his boasting, Baba Yaga raised her free hand. A blast of energy shot out of her palm and slammed into the fairy boy’s chest. The impact was so powerful, he sailed ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("across the yard and far into the field on the other side of the street.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The noise must have woken the rest of the family. Granny, Daphne, Uncle Jake, and Elvis charged outside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Put her down, Old Mother,” Granny Relda demanded, though she was rather unintimidating in curlers and fuzzy slippers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your nestling has stolen from me, Relda,” Baba Yaga snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Put her down, witch,” Uncle Jake said. “You’re not the only one who can wield magic around here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baba Yaga sneered. “Your threats mean nothing to me. They’re like a mosquito buzzing around. Hold still, and I’ll swat you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly, something big, brown, and furry raced out of the house, slamming into Baba Yaga and knocking her to the ground. The assault broke the witch’s concentration, and the suffocating grip on Sabrina’s throat vanished. She fell to the porch, clutching her throat, forcing air into her empty lungs. Tears filled her eyes, making the scene a blur, but she knew what had attacked the witch. Mr. Canis was out of his room, and he was angry.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("“Why don’t you swat me instead?” Canis said as he hovered over the hag. Baba Yaga shrieked in rage. She raised her right hand, and a ball of crackling energy materialized in her palm. Mr. Canis flew backward, slammed roughly against the house, and let out a pained groan. The impact was so violent, Sabrina was worried he wouldn’t be able to shake it off. But with animal speed ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("and reflexes, he leaped forward, snatched the witch off the ground in one of his huge hands, and tossed her at her own house. The crash was deafening. She smashed through the front wall of her shack, leaving a gaping hole between the two filthy windows. The shutters fluttered like eyelids.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Uncle Jake helped Sabrina to her feet. “What did you do that’s got her so mad?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She thinks I stole something from her,” Sabrina choked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baba Yaga appeared in one of her windows. “She has been touched!” she screamed, pointing directly at Sabrina.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re mucho crazy-o!” Daphne cried as she struggled to hold Elvis back from attacking the witch. “Worse, you’re mean. My sister didn’t steal anything from you. Leave her alone, or things are going to get ugly.” The little girl assumed her attack position and made her warrior face—a slightly comical expression she believed people found intimidating. But Granny Relda nudged both Daphne and Elvis back inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Give me what is mine, or I’ll destroy this house and everyone in it,” Baba Yaga demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have no idea what you are talking about,” Granny insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Merlin’s wand!” the witch screamed. “Your nestling has stolen it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t take anything from her!” Sabrina cried. “I wouldn’t go back to her stinking house for a million bucks!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("“Liar! Thief!” Baba Yaga shrieked.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I believe Sabrina,” Granny said firmly. “Someone else must have taken it. If you want our help getting your wand back, all you have to do is ask, but you’re not to come here and threaten my family. I don’t care who you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baba Yaga disappeared from her window. A moment later, she scurried into the Grimms’ yard, pointing her gnarled, wartcovered finger at Sabrina. “She—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have never lied to you, Old Mother,” Granny interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baba Yaga stopped in her tracks. She narrowed her eyes at Granny Relda, then Sabrina. “You will find the wand?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Granny nodded. “We’ll come out to see you in the morning, and we’ll get to the bottom of this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The witch hobbled back into her house. A moment later it rose up on its chicken legs, turned, and lumbered away. It disappeared into the woods, leaving a trail of black chimney smoke in its wake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moments later, Puck swooped back into the yard and landed in front of Sabrina with his sword clenched tightly in his hand. “Where did she go?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s gone,” Sabrina said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("“Coward! Of course she ran off,” Puck crowed. “She attacked ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("me when I wasn’t ready and then ran back to her woods! Miserable sissy!”")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, you can settle your dispute with her tomorrow. We’re going for a visit,” Granny said.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Sabrina turned to her grandmother. “If you think I’m going to that woman’s house again, you’re as crazy as she is.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“This is crazy!” Sabrina shouted as she squished through the mud with her grandmother, Daphne, and Puck. An early morning rain had soaked the woods, turning the forest floor into a chilly swamp. Puck followed Sabrina, muttering to himself about what he planned to do to Baba Yaga when he confronted her, while occasionally remembering to insult Sabrina.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hear she eats people, Grimm,” he said. “I bet she turns you all into jerky!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t want to be jerky,” Daphne cried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No one is going to get turned into jerky,” Granny said. “This is going to be nice and pleasant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what people always say before they become jerky,” Puck said. “Don’t worry, folks. I’ve got a score to settle with the witch. She’ll regret the day she laid a hand on the Trickster King.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Puck’s boasting made Sabrina nervous. Baba Yaga had a two-thousand-year-old reputation for black magic and even blacker moods. The family journals were filled with tales of her murders ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("and cannibalism. The last time Sabrina had visited her creepy house, Baba Yaga turned her into a frog and tried to eat her. The last thing they needed was for Puck to pick a fight with the crone.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They walked until they came to a part of the forest where the thin, dead trees grew had grown close together, their limbs intertwined. Though there were no leaves to block the sunshine, the space was dark and gray. Not a blade of grass sprang from the ground. Sabrina realized the natural sounds of the forest were also gone: the scurrying of animals, the wind in the branches, the crackling of earth beneath their feet—all silenced.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The family continued on until they found themselves on a path made of what looked like bleached stones. Sabrina knew where it led—straight to the man-eating witch. She also knew that the stones of the path were not what they seemed. It wasn’t long before Puck noticed as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These are human skulls!” he cried, digging one out of the ground and holding it up to the group.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t be frightened, Puck,” Granny said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Frightened? This is the coolest thing I’ve ever seen! Can we make a path like this at our house?” the boy asked. He moved the skull’s jaw up and down like a puppet and shoved it in Daphne’s face. “Hey, little girl, how about a smooch?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daphne shrieked and hid behind her sister. Granny Relda scolded Puck, demanding he return the skull to the path.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("“What happened to your revenge, Trickster King?” Sabrina asked. “All of a sudden Baba Yaga is cool?”")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just because I’m going to unleash hellfire on her doesn’t mean I can’t appreciate her style,” Puck said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Granny, what happened to the bodyguards?” Daphne asked as she peered ahead. The notorious Bright Sun, Black Midnight, and Red Dawn—each a bizarre hybrid of an animal and a man—usually guarded the old witch, but they were nowhere in sight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry about them,” Puck said. “They won’t be showing their ugly faces around here. They know better than to cross paths with me.” His voice cracked at the end of the sentence. Puck looked around as if someone else had made the noise. He repeated the word “me” with the same result.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sounds like you might be coming down with a cold,” Granny said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everafters do not get colds!” Puck argued.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nonetheless, I’ll make you some chicken soup later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The group continued down the path and soon Baba Yaga’s hut came into view. A fence made from ancient human leg and arm bones surrounded it. Granny Relda pushed open the gate and led the family into the yard. Sabrina eyed her grandmother with both awe and envy. The old woman was fearless. She strolled to the front door as if she were visiting an old friend. Sabrina wondered if she herself would ever be that courageous.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Granny knocked, and a moment later the door flew open.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re interrupting my soaps,” Baba Yaga seethed. She was eating a bowl of cereal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry,” Granny Relda replied. “We thought you’d want us to get started as soon as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The witch frowned but waved everyone into the house. The inside was as disturbing as the outside. In one corner, dusty burlap bags leaked green ooze onto the floor. Along the wall were stacks of crates, one of which seemed to have something inside struggling to break free. The brick fireplace was lit, and the flames formed the desperate faces of people begging for help. Sabrina shuddered to imagine herself trapped, suffering for eternity in Baba Yaga’s home. Still, the most unsettling thing wasn’t the filth and despair, it was the odd sensation churning in Sabrina’s gut. At first she thought it was just nerves, but she soon realized it felt more like hunger—a nervous, unnatural craving. Every drop of blood and strand of hair in her being was wide awake and starving. She glanced around at the wands, spell books, and magical rings the witch had left lying about. Baba Yaga didn’t deserve those things. Look how she misused and mistreated them!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you going to be OK?” Daphne asked, squeezing Sabrina’s arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sabrina took a deep breath and nodded. “Let’s get out of here as soon as we can.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("“Where are your guardians, Old Mother?” Granny Relda asked the witch.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“They failed me,” the witch snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not what I asked.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t question me!” the witch screamed, enraged. “I created them for a purpose. They were to guard my possessions and prevent any invasion into my home. They failed. You needn’t know more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sabrina easily read between the lines. Baba Yaga’s guardians were dead. Their bones were probably part of the fence outside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Puck, on the other hand, was completely oblivious to the conversation. He was busy snooping, opening cabinets and peeking into drawers as if he owned the place. “This book looks like it’s made out of human skin!” he exclaimed when he picked up a discarded tome off the floor. The cover looked like leather, but had hair growing out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is,” Baba Yaga confirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Puck beamed. “This place is like my Disneyland.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh, hello?” Sabrina said. “What happened to the hellfire?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Puck scowled and put the book back on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Old Mother, tell us everything you know about your missing wand,” Granny said as she took out her notebook and pen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was here one moment and gone the next,” the witch said, flashing Sabrina an accusing look.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("“Can you show us where you kept it?” Granny asked.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The crone hobbled into the next room, where the floor was covered in dust and what looked like human teeth. An overstuffed recliner faced a television that was set up against the wall. The jawbone of some huge animal rested atop the TV with an old wire hanger wrapped in tinfoil sticking out of it, making a disturbing antenna. The TV was tuned to a soap opera called "), _c('em', [_vm._v("Days of Our Lives.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I kept the wand in here,” the witch said as she gestured around the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“OK, girls. Here’s where we get to put your training into action,” Granny Relda said. “Have a look around, and remember, keep an eye out for anything that’s out of place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the last two months Granny Relda had been teaching Sabrina and Daphne to see—or rather, to observe—things. She believed good detectives used all of their senses to get the most accurate picture of a crime scene. Her method included sniffing for odd scents, listening for unusual sounds, and peeking into dark corners. Sabrina had her own method, though. She believed the best way to find a criminal was to think like one. All she had to do was think about what she might have done if she were trying to get away with something. When she combined her approach with her grandmother’s, she discovered that she could spot things that others missed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("She scanned the room, wondering what her grandmother might mean by “out of place” in this room where everything was bizarre. Ancient wallpaper was peeling from the walls. Something reddish Sabrina hoped wasn’t blood stained the floor. In the far corner, a table held little glass jars filled with greenish liquid. All manner of disgusting objects floated inside them.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sabrina?” Daphne said. “What do you see?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sabrina peered at the table but saw nothing out of the ordinary, if you considered a pile of dead chameleons ordinary. Still, Granny had taught her to be thorough, so she peeked under the table. There, she spotted a small hole in the baseboard. Daphne joined her and pointed out little greasy paw tracks and some wood shavings around the hole. The witch had mice chewing through her floors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When did you notice the wand missing?” Granny asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Late last night,” the witch said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was anything else taken?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Baba Yaga snapped. “Do you know who did it yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We just got here,” Granny said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The witch scowled. “Tomorrow I will take matters into my own hands, Relda Grimm.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Old Mother, please,” Granny begged. “You have to give us some time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You heard me. Tomorrow!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a756f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 72
// module chunks = 0